/**
 * @fileoverview ESM view of the ONE UI-language → Intl-locale mapping.
 * @module @puffin-core/i18n-bootstrap/esm/intlLocaleFor
 *
 * **There is no logic in this file.** The implementation lives once, in CJS, at
 * `../intlLocaleFor.js` — see that file for the mapping's rationale (why `es → es-US`) and
 * for why the source direction is CJS.
 *
 * Destructured default import, not `export { x } from …`: the latter is a STATIC named
 * import that bundlers cannot always satisfy through a CJS `module.exports`. Same form the
 * `esm-build` generator emits for all 21 generated packages.
 */

import intlLocale from '../intlLocaleFor.js';

export const { intlLocaleFor, INTL_LOCALE_BY_LANGUAGE } = intlLocale;

export default intlLocaleFor;
